import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/InquiryForm.tsx");
